import Loading from "../loading";
import Ajax from "../ajax";

import ExceptionHandling from "../logging/exception_handling";

import $ from "jquery";

export default function configureDataTables(currentApp) {
  $(() => {
    $("body").on(`${currentApp.name}:ajax-start.backdraft`, (evt, xhr, dataTableView) => {
      const target = (currentApp.name === 'Reporting') ? null : dataTableView.$el;
      Loading.show(target);
    });

    $("body").on(`${currentApp.name}:ajax-finish.backdraft`, (evt, xhr, textStatus, dataTableView) => {
      Loading.hide();

      let result = Ajax.parseResponse(xhr);
      if (currentApp.router && currentApp.router.activeView && currentApp.router.activeView.onDataTableAjaxFinish) {
        // onDataTableAjaxFinish used here have control over error handling
        currentApp.router.activeView.onDataTableAjaxFinish(xhr);
      } else {
        // onComplete will show a flash automatically if there are errors
        Ajax.onComplete(result, xhr.responseText);
      }

      if (!result.success) {
        // successful responses will already set processing to off
        dataTableView.dataTable._fnProcessingDisplay(false);
      }
    });

    if ($.fn.dataTableExt) {
      $.fn.dataTableExt.sErrMode = (settings, dataTableErrorNumber, message) => {
        ExceptionHandling.handleException(message, "InvocaApp::DataTable error");
      };
    }
  });
}
